module.exports = {"base_url":"","debug_mode":true,"shipping":{"delivery_cutoff":{"to":"12:00 AM","from":"05:00 PM"}},"order":{"enable_weight_limit":true,"max_weight":10000}}


//////////////////
// WEBPACK FOOTER
// ./static/json/config.json
// module id = Ik+k
// module chunks = 1